import Image from 'components/Basic/Image/Image';
import { FaqAccordion } from 'components/Blocks/FaqAccordion/FaqAccordion';
import LimitHeightWrap from 'components/Helpers/LimitHeightWrap/LimitHeightWrap';
import useTranslation from 'next-translate/useTranslation';
import React, { ReactNode } from 'react';
import { FaqItemType } from 'types/faq';
import twMerge from 'utils/twMerge';

type CategoryHeaderProps = {
    title: string | null | undefined;
    description: string | null;
    slug: string;
    uuid: string;
    imageSrc: string | null;
    name: string;
    adverts?: ReactNode;
    currentPage: number;
    className?: string;
    faq?: FaqItemType[];
};

export const CategoryHeader: FC<CategoryHeaderProps> = ({
    adverts,
    currentPage,
    description,
    slug,
    uuid,
    imageSrc,
    name,
    title,
    className,
    faq = [],
}) => {
    const { t } = useTranslation();

    return (
        <div className={twMerge('mb-10 flex w-full justify-between', className)}>
            <div className="max-w-[700px]">
                {adverts}
                <h1 data-testid="basic-heading-h1">{title}</h1>
                {(description !== null || faq.length > 0) && currentPage === 1 && (
                    <LimitHeightWrap
                        isDefaultCollapsed
                        buttonAlign="left"
                        buttonClassName="pl-0"
                        buttonLabelLess={t('Read less')}
                        buttonLabelMore={t('Read more')}
                        buttonVariant="link"
                        desktopHeight={120}
                        mobileHeight={120}
                        updateDependency={slug}
                    >
                        <>
                            {description !== null && (
                                <section
                                    className="user-text text-body leading-7 vl:text-h6 vl:leading-8"
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            )}
                            {faq.length > 0 && <FaqAccordion items={faq} />}
                        </>
                    </LimitHeightWrap>
                )}
            </div>
            {imageSrc !== null && currentPage === 1 && (
                <div className="ml-20 hidden h-44 w-[418px] shrink-0 vl:block">
                    <Image
                        key={uuid}
                        priority
                        alt={name}
                        className="max-h-full max-w-full"
                        height="176"
                        src={imageSrc}
                        width="418"
                    />
                </div>
            )}
        </div>
    );
};
